import { gql } from '@apollo/client'

export const VERIFY_MFA_CODE_MUTATION = gql`
  mutation VerifyMfaCodeMutation($input: VerifyMfaCodeInput!) {
    verifyMfaCode(input: $input) {
      id
      accessToken
      dashxToken
      expiresAt
      status
      accountId
    }
  }
`

export const SEND_MFA_CODE_MUTATION = gql`
  mutation SendMfaCodeMutation($input: SendMfaCodeInput!) {
    sendMfaCode(input: $input) {
      channel
      targetMasked
    }
  }
`

export const BEGIN_MFA_ENROLLMENT_MUTATION = gql`
  mutation BeginMfaEnrollmentMutation($input: BeginMfaEnrollmentInput!) {
    beginMfaEnrollment(input: $input) {
      otpauthUrl
      plainSecret
      qrSvg
    }
  }
`

export const COMPLETE_MFA_ENROLLMENT_MUTATION = gql`
  mutation CompleteMfaEnrollmentMutation($input: CompleteMfaEnrollmentInput!) {
    completeMfaEnrollment(input: $input) {
      id
      status
      accessToken
      dashxToken
      expiresAt
      accountId
    }
  }
`
